import React, { useState } from 'react';
import { ArrowLeftIcon, PlusIcon, InfoIcon, PencilIcon, CheckIcon, TrashIcon, XIcon, SearchIcon } from 'lucide-react';
interface Foreman {
  id: string;
  name: string;
  phone: string;
  primaryJobSite: string;
  status: 'active' | 'inactive';
  phoneSharing: string;
}
interface ManageForemenPageProps {
  onBack: () => void;
}
export const ManageForemenPage = ({
  onBack
}: ManageForemenPageProps) => {
  const [showAddForm, setShowAddForm] = useState(false);
  const [foremen, setForemen] = useState<Foreman[]>([{
    id: '1',
    name: 'John Smith',
    phone: '555-123-4567',
    primaryJobSite: 'Downtown Project',
    status: 'active',
    phoneSharing: 'App messages only'
  }, {
    id: '2',
    name: 'Mike Johnson',
    phone: '555-987-6543',
    primaryJobSite: 'Highway Expansion',
    status: 'active',
    phoneSharing: 'App messages only'
  }, {
    id: '3',
    name: 'Sarah Williams',
    phone: '555-456-7890',
    primaryJobSite: 'North Quarry',
    status: 'active',
    phoneSharing: 'App messages only'
  }]);
  const handleAddForeman = (newForeman: Omit<Foreman, 'id'>) => {
    const id = (foremen.length + 1).toString();
    setForemen([...foremen, {
      ...newForeman,
      id
    }]);
    setShowAddForm(false);
  };
  return <div className="p-6 w-full" data-id="element-2029">
      <div className="flex justify-between items-center mb-6" data-id="element-2030">
        <div className="w-1/3" data-id="element-2031"></div>
        <h1 className="text-2xl font-bold text-center w-1/3" data-id="element-2032">Manage Foremen</h1>
        <div className="flex justify-end w-1/3" data-id="element-2033">
          <button className="bg-gray-600 hover:bg-gray-700 text-white px-4 py-2 rounded-md flex items-center gap-2" onClick={onBack} data-id="element-2034">
            Back to Dashboard
          </button>
        </div>
      </div>
      <div className="flex justify-between items-center mb-4" data-id="element-2035">
        <div className="w-1/3" data-id="element-2036"></div>
        <h2 className="text-xl font-medium text-center w-1/3" data-id="element-2037">Your Foremen</h2>
        <div className="flex justify-end w-1/3" data-id="element-2038">
          <button className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-md flex items-center gap-2" onClick={() => setShowAddForm(true)} data-id="element-2039">
            <PlusIcon size={18} data-id="element-2040" />
            Add Foreman
          </button>
        </div>
      </div>
      <div className="bg-blue-50 border border-blue-200 rounded-md p-4 mb-6 flex items-start gap-3" data-id="element-2041">
        <InfoIcon size={20} className="text-blue-500 mt-0.5 flex-shrink-0" data-id="element-2042" />
        <div data-id="element-2043">
          <div className="font-medium text-blue-800" data-id="element-2044">Why Manage Foremen?</div>
          <p className="text-blue-700 text-sm" data-id="element-2045">
            Adding your foremen here allows you to quickly select them when
            creating jobs. This information is passed to brokers and drivers to
            facilitate better communication.
          </p>
        </div>
      </div>
      {showAddForm ? <AddForemanForm onSave={handleAddForeman} onCancel={() => setShowAddForm(false)} data-id="element-2046" /> : <div className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-2047">
          <table className="w-full" data-id="element-2048">
            <thead data-id="element-2049">
              <tr className="bg-gray-50 text-left" data-id="element-2050">
                <th className="px-6 py-3 text-gray-600 font-medium" data-id="element-2051">NAME</th>
                <th className="px-6 py-3 text-gray-600 font-medium" data-id="element-2052">PHONE</th>
                <th className="px-6 py-3 text-gray-600 font-medium" data-id="element-2053">
                  PRIMARY JOB SITE
                </th>
                <th className="px-6 py-3 text-gray-600 font-medium" data-id="element-2054">STATUS</th>
                <th className="px-6 py-3 text-gray-600 font-medium" data-id="element-2055">
                  PHONE SHARING
                </th>
                <th className="px-6 py-3 text-gray-600 font-medium" data-id="element-2056">ACTIONS</th>
              </tr>
            </thead>
            <tbody className="divide-y" data-id="element-2057">
              {foremen.map(foreman => <tr key={foreman.id} className="hover:bg-gray-50" data-id="element-2058">
                  <td className="px-6 py-4" data-id="element-2059">{foreman.name}</td>
                  <td className="px-6 py-4" data-id="element-2060">{foreman.phone}</td>
                  <td className="px-6 py-4" data-id="element-2061">{foreman.primaryJobSite}</td>
                  <td className="px-6 py-4" data-id="element-2062">
                    <span className="px-2 py-1 bg-green-100 text-green-800 rounded-full text-xs font-medium" data-id="element-2063">
                      {foreman.status === 'active' ? 'Active' : 'Inactive'}
                    </span>
                  </td>
                  <td className="px-6 py-4" data-id="element-2064">
                    <div className="flex items-center" data-id="element-2065">
                      <input type="checkbox" className="mr-2" checked data-id="element-2066" />
                      <span className="text-sm" data-id="element-2067">{foreman.phoneSharing}</span>
                    </div>
                  </td>
                  <td className="px-6 py-4" data-id="element-2068">
                    <div className="flex gap-2" data-id="element-2069">
                      <button className="text-blue-600 hover:text-blue-800" data-id="element-2070">
                        <PencilIcon size={18} data-id="element-2071" />
                      </button>
                      <button className="text-green-600 hover:text-green-800" data-id="element-2072">
                        <CheckIcon size={18} data-id="element-2073" />
                      </button>
                      <button className="text-red-600 hover:text-red-800" data-id="element-2074">
                        <TrashIcon size={18} data-id="element-2075" />
                      </button>
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>}
    </div>;
};
interface AddForemanFormProps {
  onSave: (foreman: Omit<Foreman, 'id'>) => void;
  onCancel: () => void;
}
const AddForemanForm = ({
  onSave,
  onCancel
}: AddForemanFormProps) => {
  const [formData, setFormData] = useState<Omit<Foreman, 'id'>>({
    name: '',
    phone: '',
    primaryJobSite: '',
    status: 'active',
    phoneSharing: 'App messages only'
  });
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const {
      name,
      value
    } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSave(formData);
  };
  return <div className="bg-white rounded-lg shadow-md p-6" data-id="element-2076">
      <div className="flex justify-between items-center mb-4" data-id="element-2077">
        <h3 className="text-lg font-medium" data-id="element-2078">Add New Foreman</h3>
        <button onClick={onCancel} className="text-gray-500 hover:text-gray-700" data-id="element-2079">
          <XIcon size={20} data-id="element-2080" />
        </button>
      </div>
      <form onSubmit={handleSubmit} data-id="element-2081">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" data-id="element-2082">
          <div data-id="element-2083">
            <label className="block text-sm font-medium mb-2" data-id="element-2084">Full Name</label>
            <input type="text" name="name" value={formData.name} onChange={handleChange} className="w-full p-2 border border-gray-300 rounded-md" placeholder="Enter foreman's full name" required data-id="element-2085" />
          </div>
          <div data-id="element-2086">
            <label className="block text-sm font-medium mb-2" data-id="element-2087">
              Phone Number
            </label>
            <input type="tel" name="phone" value={formData.phone} onChange={handleChange} className="w-full p-2 border border-gray-300 rounded-md" placeholder="555-123-4567" required data-id="element-2088" />
          </div>
          <div data-id="element-2089">
            <label className="block text-sm font-medium mb-2" data-id="element-2090">
              Primary Job Site
            </label>
            <div className="relative" data-id="element-2091">
              <input type="text" name="primaryJobSite" value={formData.primaryJobSite} onChange={handleChange} className="w-full p-2 border border-gray-300 rounded-md pr-10" placeholder="Enter or select job site" required data-id="element-2092" />
              <SearchIcon size={18} className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400" data-id="element-2093" />
            </div>
          </div>
          <div data-id="element-2094">
            <label className="block text-sm font-medium mb-2" data-id="element-2095">Status</label>
            <select name="status" value={formData.status} onChange={handleChange} className="w-full p-2 border border-gray-300 rounded-md" required data-id="element-2096">
              <option value="active" data-id="element-2097">Active</option>
              <option value="inactive" data-id="element-2098">Inactive</option>
            </select>
          </div>
        </div>
        <div className="mb-6" data-id="element-2099">
          <label className="block text-sm font-medium mb-2" data-id="element-2100">
            Phone Sharing Settings
          </label>
          <div className="space-y-2" data-id="element-2101">
            <label className="flex items-center" data-id="element-2102">
              <input type="radio" name="phoneSharing" value="App messages only" checked={formData.phoneSharing === 'App messages only'} onChange={handleChange} className="mr-2" data-id="element-2103" />
              <span data-id="element-2104">App messages only (default)</span>
            </label>
            <label className="flex items-center" data-id="element-2105">
              <input type="radio" name="phoneSharing" value="Share with brokers" checked={formData.phoneSharing === 'Share with brokers'} onChange={handleChange} className="mr-2" data-id="element-2106" />
              <span data-id="element-2107">Share with brokers</span>
            </label>
            <label className="flex items-center" data-id="element-2108">
              <input type="radio" name="phoneSharing" value="Share with brokers and drivers" checked={formData.phoneSharing === 'Share with brokers and drivers'} onChange={handleChange} className="mr-2" data-id="element-2109" />
              <span data-id="element-2110">Share with brokers and drivers</span>
            </label>
          </div>
        </div>
        <div className="flex justify-end gap-3" data-id="element-2111">
          <button type="button" onClick={onCancel} className="px-4 py-2 border border-gray-300 rounded-md hover:bg-gray-50" data-id="element-2112">
            Cancel
          </button>
          <button type="submit" className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700" data-id="element-2113">
            Add Foreman
          </button>
        </div>
      </form>
    </div>;
};